import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-boolean-badge',
  templateUrl: './boolean-badge.component.html',
  styleUrls: ['./boolean-badge.component.css']
})
export class BooleanBadgeComponent implements OnInit {

  @Input() value:boolean;
  constructor() { }

  ngOnInit() {
  }

}
